import { createRouter, createWebHistory } from 'vue-router'
import Loader from '../views/Loader.vue'
import Office from '../views/Office.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Loader,
      meta: {
        title: 'Portfolio | Steven Lucarno DODDE - Développeur Web',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://dlucarno.com'
          },
          {
            name: 'title',
            content: 'Portfolio | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'description',
            content:
              "Découvrez le portfolio de Steven Lucarno DODDE, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'keywords',
            content: 'portfolio, steven lucarno, développeur web, full stack, sites web, applications web, applications mobiles, JS, PHP, SQL, ORM, frameworks, DevOps'
          },
          {
            name: 'author',
            content: 'Steven Lucarno DODDE'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'Portfolio | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'application-name',
            content: 'Portfolio | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'Portfolio | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'twitter:description',
            content:
              "Découvrez le portfolio de Steven Lucarno DODDE, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'twitter:image',
            content: 'https://dlucarno.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'twitter:image:alt',
            content: 'Logo Portfolio Steven Lucarno DODDE'
          },
          {
            property: 'og:type',
            content: 'website'
          },
          {
            property: 'og:title',
            content: 'Portfolio | Steven Lucarno DODDE - Développeur Web'
          },
          {
            property: 'og:description',
            content:
              "Découvrez le portfolio de Steven Lucarno DODDE, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            property: 'og:site_name',
            content: 'Portfolio | Steven Lucarno DODDE - Développeur Web'
          },
          {
            property: 'og:url',
            content: 'https://dlucarno.com'
          },
          {
            property: 'og:image',
            content: 'https://dlucarno.com/img/logo-portfolio-black.webp'
          },
          {
            property: 'og:image:alt',
            content: 'Logo Portfolio Steven Lucarno DODDE'
          },
          {
            property: 'og:locale',
            content: 'fr_FR'
          },
          {
            property: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    },
    {
      path: '/office',
      name: 'Office',
      component: Office,
      meta: {
        title: 'Bureau | Steven Lucarno DODDE - Développeur Web',
        metaTags: [
          {
            rel: 'canonical',
            href: 'https://dlucarno.com/office'
          },
          {
            name: 'title',
            content: 'Bureau | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'description',
            content:
              "Découvrez le bureau de Steven Lucarno DODDE, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'keywords',
            content: 'bureau, steven lucarno, développeur web, full stack, sites web, applications web, applications mobiles, JS, PHP, SQL, ORM, frameworks, DevOps'
          },
          {
            name: 'author',
            content: 'Steven Lucarno DODDE'
          },
          {
            name: 'robots',
            content: 'index, follow'
          },
          {
            name: 'theme-color',
            content: '#000000'
          },
          {
            name: 'mobile-web-app-capable',
            content: 'yes'
          },
          {
            name: 'apple-mobile-web-app-status-bar-style',
            content: 'black'
          },
          {
            name: 'apple-mobile-web-app-title',
            content: 'Bureau | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'application-name',
            content: 'Bureau | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'twitter:card',
            content: 'summary'
          },
          {
            name: 'twitter:title',
            content: 'Bureau | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'twitter:description',
            content:
              "Découvrez le bureau de Steven Lucarno DODDE, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'twitter:image',
            content: 'https://dlucarno.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'twitter:image:alt',
            content: 'Logo Portfolio Steven Lucarno DODDE'
          },
          {
            name: 'og:type',
            content: 'website'
          },
          {
            name: 'og:title',
            content: 'Bureau | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'og:description',
            content:
              "Découvrez le bureau de Steven Lucarno DODDE, développeur web full stack passionné, Création de sites et applications web et mobiles avec JS, PHP, SQL et leurs frameworks, ainsi qu'en DevOps."
          },
          {
            name: 'og:site_name',
            content: 'Bureau | Steven Lucarno DODDE - Développeur Web'
          },
          {
            name: 'og:url',
            content: 'https://dlucarno.com/office'
          },
          {
            name: 'og:image',
            content: 'https://dlucarno.com/img/logo-portfolio-black.webp'
          },
          {
            name: 'og:image:alt',
            content: 'Logo Portfolio Steven Lucarno DODDE'
          },
          {
            name: 'og:locale',
            content: 'fr_FR'
          },
          {
            name: 'og:locale:alternate',
            content: 'en_US'
          }
        ]
      }
    }
  ]
})

export default router
